<template>
    <div>
      <header>
        <h3>Past Medical History</h3>
      </header>

      <div class="content">
        <div class="form__row--x" v-if="!isClose">
          <label normal>Please add pre-existing conditions prior to present diagnosis. <br/>
            Present or newly diagnosed condition caused by or causing complication to the current diagnosis, must be added as co-morbidities in Delivery or Gyne sections.
          </label>
          <smd-select v-model="medicalHistoryModel"
                      :hide-tags="true"
                      :hide-selected="true"
                      :options="mutiSelectLookup"
                      @open="onSelectOpen"
                      @search-change="onSearchChange"/>
        </div>

        <template v-if="showContent">
          <div class="data-entry">
            <label>Category</label>
            <label>Condition</label>
          </div>

          <div class="data-entry" v-for="(value, key) in medicalHistory" :key="key">
            <p><strong>{{ value.categoryId | decodeMedicalHistoryCategory }}</strong></p>
            <p>{{ key | decodeMedicalHistoryCondition }}</p>
            <smd-btn icon="smd-icon-action-delete"
                     @click="removeMultiSelectItem(key)"
                     v-if="!isClose"/>
          </div>
        </template>
      </div>
    </div>
</template>

<script>
  import caseFormMultiSelectMixin from './case-form-section-with-multiselect'

  import {mapActions, mapGetters} from 'vuex'
  import {
    ACTION_UPDATE_MEDICAL_HISTORY,
    GETTER_IS_CLOSE
  } from '../../../store/forms/case-form-state'
  import {
    REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY,
    REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_CONDITIONS_OBJ
  } from "../../../store/modules/referencedata2";

  export default {
    mixins: [caseFormMultiSelectMixin],
    props:{
      medicalHistory: null
    },
    computed:{
      ...mapGetters({
        isClose: GETTER_IS_CLOSE
      }),
      medicalHistoryModel: {
        get() {
          return this.generateMultiSelectModel();
        },
        set(v) {
          const model = this.transformMultiSelectModel(v);
          this.doUpdateMultiSelectModel(model);
        }
      },
      showContent(){
        return !!Object.keys(this.medicalHistory).length;
      }
    },
    methods: {
      ...mapActions({
        doUpdateMultiSelectModel: ACTION_UPDATE_MEDICAL_HISTORY
      }),
      getRawModelForMultiSelect() {
        return this.medicalHistory;
      },
      onSelectOpen() {
        this.$emit('add');
      },
      onSearchChange(q) {
        this.$emit('search-change', q);
      }
    },
    multiSelectFormSection: 'medicalHistory',
    multiSelectLookupName: REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY,
    multiSelectConditionsLookupName: REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_CONDITIONS_OBJ
  }
</script>
